module.exports = __webpack_public_path__ + "img/au_gallery_4.1026974e.jpg";